import React from "react";
import { Col } from "antd";
import {
  Container,
  Heading,
  Line1,
  Line2,
  LocationButton,
  CardContainer,
  LeftAlign,
} from "./style";

const Contact = () => {
  const [formData, setFormData] = React.useState({
    fullName: '',
    email: '',
    mobile: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    console.log('Form Data:', formData);
    alert('Form submitted! Check console for form data.');
  };

  return (
    // <div style={{  border: "2px", 
    //   maxWidth: '900px', 
    //   marginTop: "30px",
    //   marginBottom: "40px", 
    //   margin: '0 auto', 
    //   padding: '20px', 
    //   background: '#fff', 
    //   borderRadius: '8px',
    //   boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>


    //   <h2 style={{ fontSize: '24px', fontWeight: '600', color: '#1e40af', marginBottom: '24px', textDecoration:"underline", paddingBottom: '8px' }}>Contact Us</h2>
    //   <div style={{ display: 'flex', maxWidth: '500px',  flexDirection: 'column', gap: '16px' ,textAlign:"center"}}>
    //     <div>
    //       <label style={{ display: 'block', fontSize: '16px', color: '#374151', fontWeight: '500', marginBottom: '4px' }}>Full name</label>
    //       <input
    //         type="text"
    //         name="fullName"
    //         value={formData.fullName}
    //         onChange={handleChange}
    //         placeholder="Enter your full name here"
    //         style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '14px', outline: 'none' }}
    //         onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
    //         onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
    //       />
    //     </div>
    //     <div>
    //       <label style={{ display: 'block', fontSize: '16px', color: '#374151', fontWeight: '500', marginBottom: '4px' }}>Email ID</label>
    //       <input
    //         type="email"
    //         name="email"
    //         value={formData.email}
    //         onChange={handleChange}
    //         placeholder="Enter your email id here"
    //         style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '14px', outline: 'none' }}
    //         onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
    //         onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
    //       />
    //     </div>
    //     <div>
    //       <label style={{ display: 'block', fontSize: '16px', color: '#374151', fontWeight: '500', marginBottom: '4px' }}>Mobile No</label>
    //       <input
    //         type="tel"
    //         name="mobile"
    //         value={formData.mobile}
    //         onChange={handleChange}
    //         placeholder="Enter your mobile no here"
    //         style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '14px', outline: 'none' }}
    //         onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
    //         onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
    //       />
    //     </div>
    //     <div>
    //       <label style={{ display: 'block', fontSize: '16px', color: '#374151', fontWeight: '500', marginBottom: '4px' }}>Subject</label>
    //       <input
    //         type="text"
    //         name="subject"
    //         value={formData.subject}
    //         onChange={handleChange}
    //         placeholder="Enter subject here"
    //         style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '14px', outline: 'none' }}
    //         onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
    //         onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
    //       />
    //     </div>
    //     <div>
    //       <label style={{ display: 'block', fontSize: '16px', color: '#374151', fontWeight: '500', marginBottom: '4px' }}>Message</label>
    //       <textarea
    //         name="message"
    //         value={formData.message}
    //         onChange={handleChange}
    //         placeholder="Enter message here"
    //         rows="4"
    //         style={{ width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '14px', outline: 'none', resize: 'vertical' }}
    //         onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
    //         onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
    //       ></textarea>
    //     </div>
    //     <div style={{ textAlign: 'right' }}>
    //       <button
    //         onClick={handleSubmit}
    //         style={{ background: '#1e40af', color: '#fff', fontWeight: '600', padding: '8px 24px', borderRadius: '20px', border: 'none', cursor: 'pointer' }}
    //         onMouseOver={(e) => e.target.style.background = '#1e3a8a'}
    //         onMouseOut={(e) => e.target.style.background = '#1e40af'}
    //       >
    //         SUBMIT
    //       </button>
    //     </div>
    //   </div>
    // </div>
    <div style={{
      border: "2px", 
      maxWidth: '900px', 
      marginTop: "20px", 
      marginBottom: "40px", 
      margin: '0 auto', 
      padding: '20px', 
      background: '#fff', 
      borderRadius: '8px', 
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
    }}>
      <h2 style={{
        fontSize: '24px', 
        fontWeight: '600', 
        color: '#1e40af', 
        marginBottom: '24px', 
        textDecoration: "underline", 
        paddingBottom: '8px'
      }}>
        Contact Us
      </h2>
      <div style={{
        display: 'flex', 
        flexDirection: 'column', 
        gap: '16px', 
        textAlign: "left", 
        alignItems: 'center',  // Center the content horizontally
        maxWidth: '500px', 
        margin: '0 auto'  // Center the whole form horizontally
      }}>
        <div>
          <label style={{
            display: 'block', 
            fontSize: '16px', 
            color: '#374151', 
            fontWeight: '500', 
            marginBottom: '4px'
          }}>
            Full name
          </label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Enter your full name here"
            style={{
              width: '300px', 
              padding: '8px', 
              border: '1px solid #d1d5db', 
              borderRadius: '4px', 
              fontSize: '14px', 
              outline: 'none'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
        <div>
          <label style={{
            display: 'block', 
            fontSize: '16px', 
            color: '#374151', 
            fontWeight: '500', 
            marginBottom: '4px'
          }}>
            Email ID
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email id here"
            style={{
              width: '300px', 
              padding: '8px', 
              border: '1px solid #d1d5db', 
              borderRadius: '4px', 
              fontSize: '14px', 
              outline: 'none'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
        <div>
          <label style={{
            display: 'block', 
            fontSize: '16px', 
            color: '#374151', 
            fontWeight: '500', 
            marginBottom: '4px'
          }}>
            Mobile No
          </label>
          <input
            type="tel"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            placeholder="Enter your mobile no here"
            style={{
              width: '300px', 
              padding: '8px', 
              border: '1px solid #d1d5db', 
              borderRadius: '4px', 
              fontSize: '14px', 
              outline: 'none'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
        <div>
          <label style={{
            display: 'block', 
            fontSize: '16px', 
            color: '#374151', 
            fontWeight: '500', 
            marginBottom: '4px'
          }}>
            Subject
          </label>
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Enter subject here"
            style={{
              width: '300px', 
              padding: '8px', 
              border: '1px solid #d1d5db', 
              borderRadius: '4px', 
              fontSize: '14px', 
              outline: 'none'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
        <div>
          <label style={{
            display: 'block', 
            fontSize: '16px', 
            color: '#374151', 
            fontWeight: '500', 
            marginBottom: '4px'
          }}>
            Message
          </label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Enter message here"
            rows="4"
            style={{
              width: '300px', 
              padding: '8px', 
              border: '1px solid #d1d5db', 
              borderRadius: '4px', 
              fontSize: '14px', 
              outline: 'none', 
              resize: 'vertical'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          ></textarea>
        </div>
        <div style={{ textAlign: 'right' }}>
          <button
            onClick={handleSubmit}
            style={{
              background: '#193367', 
              color: '#fff', 
              width:"200px",
              fontWeight: '600', 
              padding: '8px 24px', 
              borderRadius: '20px', 
              border: 'none', 
              cursor: 'pointer'
            }}
            onMouseOver={(e) => e.target.style.background = '#1e3a8a'}
            onMouseOut={(e) => e.target.style.background = '#193367'}
          >
            SUBMIT
          </button>
        </div>
      </div>
    </div>
    
  );
};

export default Contact;
